/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.event-form-dialog{width:100%}}@media screen and (min-width:600px){.event-form-dialog{width:480px}}.event-form-dialog .mat-dialog-container{padding:0}.event-form-dialog .dialog-content-wrapper{max-height:85vh;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.event-form-dialog .primary-color-input,.event-form-dialog .secondary-color-input{padding:6px 8px}"];
export { styles as styles };
